import * as React from 'react';
import checkGreenSvg from '../../../../images/checkGreen.svg';
import PageTitle from '../../common/PageTitle';
import { ContentLogoWrapper, ContentLogo, SubTitleParagraph } from '../../common/Layout';
import { loginPageUrl } from '../../../../core/constants';
import FormButtons from '../../common/FormButton';
import { useNavigateWithAppName } from '../../../common/NavigateWithAppName';

const ResetPasswordSuccessForm = () => {
	const navigate = useNavigateWithAppName();

	const handleBackToLoginPage = () => {
		navigate(loginPageUrl);
	};

	return (
		<>
			<ContentLogoWrapper>
				<ContentLogo src={checkGreenSvg} alt="Check icon" />
			</ContentLogoWrapper>
			<PageTitle title="Password successfully updated" />
			<SubTitleParagraph>Your password has been reset. Please log in to continue.</SubTitleParagraph>
			<FormButtons continueButtonText="Login" onContinueButtonClick={handleBackToLoginPage} />
		</>
	);
};

export default ResetPasswordSuccessForm;
